import { RouteRecordRaw } from "vue-router";

export const myTaskRouter: RouteRecordRaw[] = [
    {
        path: "/myTask",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/myTask/index",
        name: "MyTask",
        meta: {
            title: "待办工作",
            icon: "icon-daibangongzuo"
        },
        children: [
            {
                path: "index",
                name: "MyTaskIndex",
                component: () => import("@/views/pages/myTask/index.vue"),
                meta: {
                    title: "待办工作",
                    activeMenu: "MyTask",
                    isNotShowHeader: true,
                    hidden: true
                }
            }
        ]
    }
];

export default myTaskRouter;
